// extracted by mini-css-extract-plugin
export default {"titleCta":"fNMHlO_6bEb82CGDMbu6","wantParticipeBtn":"ujI3GsFC8r8ZdrnmV7cQ","btnCustom":"FB8fjx1ok7cNVd7oHUhA"};